<template>
  <div class="info-card">
    <div class="card-header">
      <div class="card-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
      <h3>Diák adatai</h3>
    </div>
    
    <div class="info-list" v-if="childInfo">
      <div class="info-item">
        <div class="info-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 12l2 2 4-4"/>
            <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
            <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
            <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
            <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
          </svg>
          Fejlődés
        </div>
        <div class="info-value" v-if="(isAdmin || canEdit) && isEditingEnabled" @dblclick="editField('childxskill')">
          <span v-if="!isEditingField.childxskill">{{ childInfo.childxskill || 'Nincs megadva' }}</span>
          <textarea v-if="isEditingField.childxskill" v-model="childInfo.childxskill" @keydown.enter="saveField('childxskill')" @blur="saveField('childxskill')" class="modern-input"></textarea>
        </div>
        <div class="info-value" v-else>{{ childInfo.childxskill || 'Nincs megadva' }}</div>
      </div>

      <div class="info-item">
        <div class="info-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          Vezetéknév
        </div>
        <div class="info-value" v-if="(isAdmin || canEdit) && isEditingEnabled" @dblclick="editField('childxfamily_name')">
          <span v-if="!isEditingField.childxfamily_name">{{ childInfo.childxfamily_name }}</span>
          <input v-if="isEditingField.childxfamily_name" v-model="childInfo.childxfamily_name" @keydown.enter="saveField('childxfamily_name')" @blur="saveField('childxfamily_name')" class="modern-input">
        </div>
        <div class="info-value" v-else>{{ childInfo.childxfamily_name }}</div>
      </div>

      <div class="info-item">
        <div class="info-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          Keresztnév
        </div>
        <div class="info-value" v-if="(isAdmin || canEdit) && isEditingEnabled" @dblclick="editField('childxsure_name')">
          <span v-if="!isEditingField.childxsure_name">{{ childInfo.childxsure_name }}</span>
          <input v-if="isEditingField.childxsure_name" v-model="childInfo.childxsure_name" @keydown.enter="saveField('childxsure_name')" @blur="saveField('childxsure_name')" class="modern-input">
        </div>
        <div class="info-value" v-else>{{ childInfo.childxsure_name }}</div>
      </div>

      <div class="info-item">
        <div class="info-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
          </svg>
          Lakcím
        </div>
        <div class="info-value" v-if="(isAdmin || canEdit) && isEditingEnabled" @dblclick="editField('childxaddr')">
          <span v-if="!isEditingField.childxaddr">{{ childInfo.childxaddr || 'Nincs megadva' }}</span>
          <input v-if="isEditingField.childxaddr" v-model="childInfo.childxaddr" @keydown.enter="saveField('childxaddr')" @blur="saveField('childxaddr')" class="modern-input">
        </div>
        <div class="info-value" v-else>{{ childInfo.childxaddr || 'Nincs megadva' }}</div>
      </div>

      <!-- Táncos saját email címe -->
      <div class="info-item" v-if="childInfo.dancer_email">
        <div class="info-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          Táncos e-mail címe
        </div>
        <div class="info-value d-flex align-items-center justify-content-between flex-wrap gap-2">
          <span class="fw-semibold">{{ childInfo.dancer_email }}</span>
          <button
            v-if="canEdit || isAdmin"
            type="button"
            class="modern-btn modern-btn--secondary btn-sm px-2.5 py-1 text-nowrap d-inline-flex align-items-center gap-1.5 forfeit-btn"
            @click="$emit('open-forfeit-email')"
            title="E-mail cím átadása a szülőnek / gondviselőnek"
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 1l4 4-4 4"/>
              <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
              <path d="M7 23l-4-4 4-4"/>
              <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
            </svg>
            Átadás szülőnek
          </button>
        </div>
      </div>

      <div class="info-item" v-if="isAdmin || isTeacher || isAssistant">
        <div class="info-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
          Versenyző
        </div>
        <div class="info-value">
          <label class="toggle-switch">
            <input type="checkbox" :checked="childInfo.is_competitor" @change="$emit('toggle-competitor', $event.target.checked)">
            <span class="toggle-slider"></span>
            <span class="toggle-text">{{ childInfo.is_competitor ? 'Igen (Versenyző)' : 'Nem' }}</span>
          </label>
        </div>
      </div>

      <div class="info-item" v-if="childInfo.mainUserBirthDate && childInfo.mainUserBirthDate.Valid">
        <div class="info-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          Születési dátum
        </div>
        <div class="info-value">{{ childInfo.mainUserBirthDate.String }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChildPersonalDetailsCard',
  props: {
    childInfo: {
      type: Object,
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isTeacher: {
      type: Boolean,
      default: false
    },
    isAssistant: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    isEditingEnabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['save-field', 'toggle-competitor', 'open-forfeit-email'],
  data() {
    return {
      isEditingField: {
        childxskill: false,
        childxfamily_name: false,
        childxsure_name: false,
        childxaddr: false
      }
    };
  },
  methods: {
    editField(field) {
      this.isEditingField[field] = true;
    },
    saveField(field) {
      this.isEditingField[field] = false;
      this.$emit('save-field', { field, value: this.childInfo[field] });
    }
  }
};
</script>

<style scoped>
.info-card {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--color-background-soft);
  border-bottom: 1px solid var(--color-border);
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--button-primary, #2563eb);
  border-radius: 12px;
  color: white;
}

.card-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
}

.info-list {
  padding: 1.5rem 2rem;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid var(--color-border);
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 140px;
  font-weight: 600;
  color: var(--color-text);
}

.info-label svg {
  color: var(--button-primary, #2563eb);
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  color: var(--color-text-muted);
  word-break: break-word;
}

/* Competitor Toggle Switch */
.toggle-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  user-select: none;
}
.toggle-switch input {
  display: none;
}
.toggle-slider {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: var(--color-border, #ccc);
  border-radius: 24px;
  transition: background-color 0.25s ease;
}
.toggle-slider::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.25s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.toggle-switch input:checked + .toggle-slider {
  background-color: var(--button-primary, #2563eb);
}
.toggle-switch input:checked + .toggle-slider::before {
  transform: translateX(20px);
}
.toggle-text {
  font-weight: 500;
  color: var(--color-text);
  font-size: 0.95rem;
}
.forfeit-btn {
  font-size: 0.8rem;
  padding: 0.25rem 0.65rem;
  border-radius: 8px;
  background-color: var(--color-background-soft);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  transition: all 0.2s ease;
}
.forfeit-btn:hover {
  background-color: rgba(99, 102, 241, 0.12);
  border-color: rgba(99, 102, 241, 0.35);
  color: #4f46e5;
}
[data-theme="dark"] .forfeit-btn:hover {
  background-color: rgba(99, 102, 241, 0.25);
  border-color: rgba(99, 102, 241, 0.5);
  color: #a5b4fc;
}
</style>
